import { ref } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useErrorHandlerStore } from '~/stores/useErrorHandlerStore';

export default function useErrorHandler () {
  const errorHandlerStore = useErrorHandlerStore()
  const { requestErrors } = storeToRefs(errorHandlerStore)
  const errors = ref([])
  const catchApiFailureWithNoAction = (error) => {
    // we can perform some cation if needed but nothing is defined yet
    errors.value.push(error)
  }
  const redirectToErrorPage = (statusCode) => {
    $nuxt.error({ statusCode })
  }
  const invokeSnackBar = () => {
    const message = 'Der er gået kludder i vores system, prøv igen om lidt.'
    $nuxt.$emit('notificationSnackbar', message)
  }
  const performFlowFailure = (statusCode = 500) => {
    $nuxt.$emit('flowStepFailure')
    redirectToErrorPage(statusCode)
  }
  const stopFlow = () => {
    $nuxt.$emit('flowStepFailure')
  }
  const setRequestError = (errorResponse) => {
    requestErrors.value.set(errorResponse.url, errorResponse.data);
  }
  const getRequestError = (requestUrl) => {
    const returnVal = requestErrors.value.get(requestUrl)
    requestErrors.value.delete(requestUrl);
    return returnVal;
  };
  const hasRequestError = (requestUrl) => requestErrors.value.has(requestUrl);

  return {
    stopFlow,
    catchApiFailureWithNoAction,
    invokeSnackBar,
    redirectToErrorPage,
    performFlowFailure,
    setRequestError,
    getRequestError,
    hasRequestError
  }
}
